module.exports = __webpack_public_path__ + "img/location.f461ef61.svg";